import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MovieCard from "../components/MovieCard/MovieCardSort";
import MovieCardSlider from './../components/MovieCardSlider/MovieCardSlider';
import "../assets/styles/css/SortPage.css";
import Loading from "../components/Loading/Loading";
import { getMoviesByCategory } from "../api/movieApi";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import { GrFormNext } from "react-icons/gr";
import { GrFormPrevious } from "react-icons/gr";

const MovieOtherPage = () => {
  const { category } = useParams();
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(window.innerWidth < 700 ? 12 : 10);
  const [fetchHistory, setFetchHistory] = useState({});
  const allowedCategories = ["phim-le", "phim-bo", "hoat-hinh", "tv-shows"];

  const convertCategoryName = (category) => {
    const categoryMap = {
      "phim-le": "Phim Lẻ",
      "phim-bo": "Phim Bộ",
      "hoat-hinh": "Phim Hoạt Hình",
      "tv-shows": "TV Show",
    };

    return categoryMap[category] || category.replace("-", " ");
  };

  useEffect(() => {
    const handleResize = () => {
      setLimit(window.innerWidth > 500 && window.innerWidth < 1400 ? 12 : 10);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchMovies = async () => {
      const fetchKey = `${category}-${currentPage}`; 
      if (fetchHistory[fetchKey]) {
        setMovies(fetchHistory[fetchKey]);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        if (!allowedCategories.includes(category)) {
          throw new Error("Danh mục không hợp lệ");
        }

        const response = await getMoviesByCategory(category, currentPage, limit);
        const moviesData = response.data?.data?.items || [];
        setMovies(moviesData);

        setFetchHistory((prev) => ({
          ...prev,
          [fetchKey]: moviesData,
        }));
      } catch (err) {
        setError(err.message || "Failed to fetch movies");
      } finally {
        setLoading(false);
      }
    };

    fetchMovies();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category, currentPage, limit, fetchHistory]);

  const handlePageChange = (page) => {
    if (page >= 1 && page !== currentPage) {
      setCurrentPage(page);
    }
  };

  if (loading) return <Loading />;
  if (error) return <p className="error">{error}</p>;

  return (
    <div className="sort-page">
      {currentPage === 1 && movies.length > 0 && (
        <div className="slider-wrapper">
          <MovieCardSlider movies={movies.slice(0, 5)} />
        </div>
      )}
      <Breadcrumb />
      <h1 className="name-sort">{`Danh sách ${convertCategoryName(category)}`}</h1>
      <div className="movies-list">
        {movies.length > 0 ? (
          movies.map((movie) => <MovieCard key={movie._id} movie={movie} />)
        ) : (
          <p className="not-found">Không tìm thấy phim nào.</p>
        )}
      </div>
      <div className="pagination-controls">
        <button
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          <GrFormPrevious/>
        </button>
        {Array.from({ length: 5 }, (_, index) => (
          <button
            key={index + 1}
            className={currentPage === index + 1 ? "active" : ""}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </button>
        ))}
        <button onClick={() => handlePageChange(currentPage + 1)}>
          <GrFormNext/>
        </button>
      </div>
    </div>
  );
};

export default MovieOtherPage;
